
  window.addEventListener('scroll', function () {
    const bar = document.querySelector('.announcement_bar_outer');
    if (!bar) return;
    if (window.scrollY > 50) {
      bar.classList.add('scrolled');
    } else {
      bar.classList.remove('scrolled');
    }
  });

